<div class="widget-wrapper" *ngIf="interact.showHelpUI">
  <swapp-feedback *ngIf="interact.showHelpUI === 'feedback'"></swapp-feedback>
  <swapp-chat *ngIf="interact.showHelpUI === 'support'"></swapp-chat>
</div>